import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=cbb8e428&scoped=true&"
import script from "./Personal.vue?vue&type=script&lang=ts&"
export * from "./Personal.vue?vue&type=script&lang=ts&"
import style0 from "./Personal.vue?vue&type=style&index=0&id=cbb8e428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb8e428",
  null
  
)

export default component.exports